<template>
  <div>
    <textarea ref="editorElement"></textarea>
  </div>
</template>

<style>
.editor-row {
  position: fixed;
  text-align:right;
  margin-right: 50px!important;
  margin-bottom: 5px!important;
  bottom: 0;
  right: 0;
  z-index: 1000;
}
</style>
<script>
/* eslint-disable */
// import api from '@/api'
import utils from '../../utils';
import campaignAPIs from '../views/Campaign/campaignAPIs'
// import { VueEditor, Quill } from 'vue2-editor'
// import ImageResize from 'quill-image-resize-module'
import * as pdfMake from 'pdfmake/build/pdfmake.js';
// import * as pdfFonts from '../../components/views/Campaign/custom-fonts';
// const vfs = pdfFonts.pdfMake.vfs;
// // Quill.register('modules/imageResize', ImageResize)
// setTimeout(() => {
//   pdfMake.vfs = vfs
// }, 100)
import 'suneditor/dist/css/suneditor.min.css'
import suneditor from 'suneditor'
import plugins from 'suneditor/src/plugins'


export default {
  name: 'SunEditor',
  props: {
    value: {
      type: String,
      default: undefined
    },
    content: {
      type: String,
      default: ''
    },
    editorOpened: Boolean,
    width: [String, Number],
    height: [String, Number],
    source: String,
    placeholder: {
      type: String,
      default: ''
    },
    buttonList: {
      type: Array,
      default: null
    },
   
  },
  data() {
    return {              
      editorData: {},
      loader: null,
      loading: false,
      editor: null,
      lastEditorContent: null,
    }
  },
  watch: {
    value: {
      handler: function(val) {
        this.syncEditorContent(val);
      },
    },
    content: {
      handler: function(val) {
        if (this.value === undefined) this.syncEditorContent(val);
      },
    },
  },   
  mounted() {  
      setTimeout(function() {
        pdfMake.fonts = {
          Arial: {
            normal: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
            bold: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF'
          }
        }
      }, 1000);
      this.editor = suneditor.create(this.$refs.editorElement, {
          plugins: plugins,
          width: this.width || 930,
          height: this.height || 500,
          placeholder: this.placeholder,
          buttonList: this.buttonList || [
              ['undo', 'redo'],
              ['font', 'fontSize', 'formatBlock'],
              ['paragraphStyle', 'blockquote'],
              ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
              ['fontColor', 'hiliteColor', 'textStyle'],
              ['removeFormat'],
              '/', // Line break
              ['outdent', 'indent'],
              ['align', 'horizontalRule', 'list', 'lineHeight'],
              ['table', 'link'],
              ['fullScreen', 'showBlocks', 'codeView'],
          ]
      })
      this.editor.setDefaultStyle('font-family: Arial');
      let vm = this
      const initialContent = this.value !== undefined ? this.value : this.content;
      this.lastEditorContent = initialContent || '';
      this.editor.setContents(this.lastEditorContent);
      this.editor.onChange = function (contents, core) {
        vm.lastEditorContent = contents;
        vm.$emit('input', contents)
        vm.$emit('contentChanged', contents)
      }
      this.editor.onImageUploadBefore = function (files, info, core, uploadHandler) {
        let file = files[0]
        vm.$emit('loadingDialogOpen')
        var formData = new FormData();
        formData.append("image", file);
        campaignAPIs
          .uploadEditorImage(formData)
          .then(response => {
            vm.$emit('loadingDialogClose')
            if (response) {
              const url = utils.func.constructImageURL(response.url); // Get url from response
              vm.editor.insertHTML(`<img src="${url}">`, true, true);
            }
          })
        .catch(error => {
          vm.$emit('loadingDialogClose')
          // Request failed.
          console.log('error', error);
          vm.$swal({
            text: error,
            type: 'error'
          });
        });
        return false
      }

      // // You can also load what you want
      // this.editor = suneditor.create('sample', {
      //     plugins: [plugins.font],
      //     // Plugins can be used directly in the button list
      //     buttonList: [
      //         ['font', plugins.image]
      //     ]
      // })
    },
  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy();
      this.editor = null;
    }
  },
  methods: {
    syncEditorContent(value) {
      if (!this.editor) return;

      const nextContent = value || '';
      if (nextContent === this.lastEditorContent) return;

      if (this.editor.getContents() !== nextContent) {
        this.editor.setContents(nextContent);
      }
      this.lastEditorContent = nextContent;
    },

  }
}
</script>



// WEBPACK FOOTER //
// sunEditor.vue?1bd2ef0c